import Backbone from 'backbone'

var LoadingModel = Backbone.Model.extend({
  defaults: function () {
    return {
      isLoading: false,
    }
  },
  startLoading: function () {
    this.set({ isLoading: true })
  },
  endLoading: function () {
    this.set({ isLoading: false })
  },
})

export var loadingModel = new LoadingModel()
